import { render } from "./ErrorAlert.vue?vue&type=template&id=6a839406&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"

import "./ErrorAlert.vue?vue&type=style&index=0&id=6a839406&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a839406"]])

export default __exports__